import { settingsStore } from '../../../factories/database/settings-store'

const POS_STATE_KEY = 'POS_STATE'

function getItem(key: string) {
  if (key !== 'persist:posState') {
    return Promise.resolve(null)
  }
  return settingsStore.get(POS_STATE_KEY)
}

function setItem(key: string, item: any) {
  if (key !== 'persist:posState') {
    return Promise.resolve()
  }
  return settingsStore.put(POS_STATE_KEY, item)
}

function removeItem(_key: string) {
  // We currently have no use case for deleting the persisted state from IndexedDB
  return Promise.resolve()
}

/**
 * The configuration to pass to persistReducer for persisting the posState Redux state to the settings store in
 * IndexedDB.
 */
export const persistConfig = {
  key: 'posState',
  version: 1,
  storage: {
    getItem,
    setItem,
    removeItem,
  },
  serialize: false,
  deserialize: false,
}
